import { useEffect } from 'react';

const useAudioDevice = (audioRef, audio) => {
    useEffect(() => {
        const audRef = audioRef.current;
        const setDevice = async () => {
            if (!audRef) {
                console.warn('Audio ref not available');
                return;
            }
            if (!audRef.setSinkId) {
                console.warn('setSinkId not supported in this browser. Audio will play through default device.');
                return;
            }
            if (audio && audio.deviceId) {
                try {
                    const deviceId = audio.deviceId === 'default' ? '' : audio.deviceId;
                    await audRef.setSinkId(deviceId);
                    console.log(`Success, audio output set to ${deviceId || 'default'}`);

                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        const retryOnInteraction = async () => {
                            try {
                                const deviceId = audio.deviceId === 'default' ? '' : audio.deviceId;
                                await audRef.setSinkId(deviceId);
                                console.log(`Success after user gesture, audio output set to ${deviceId || 'default'}`);

                            } catch (retryError) {
                                console.error('Error setting audio output device:', retryError);
                            }
                        };
                        document.addEventListener('click', retryOnInteraction, { once: true });
                        document.addEventListener('touchstart', retryOnInteraction, { once: true });

                        console.warn('Audio device change requires user interaction in Safari. Will retry on next click/touch.');
                    } else {
                        console.error('Error setting audio output device:', error);
                    }
                }
            }
        };

        setDevice();
    }, [audio]);
}
export default useAudioDevice;